import { render } from "./UpgraderFilterSort.vue?vue&type=template&id=68c9b0bc&scoped=true"
import script from "./UpgraderFilterSort.vue?vue&type=script&lang=js"
export * from "./UpgraderFilterSort.vue?vue&type=script&lang=js"

import "./UpgraderFilterSort.vue?vue&type=style&index=0&id=68c9b0bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c9b0bc"]])

export default __exports__